import { ObservedValueOf, of, OperatorFunction, Observable, combineLatest } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { GraphQLFilter, GraphQlQuery } from "../../../services/GraphQl/IGraphQL.service";



export function GraphQlAppendWheres(...wheres: Observable<GraphQLFilter[]>[]): OperatorFunction<GraphQlQuery, GraphQlQuery> {

  return switchMap(query => {
    return combineLatest(wheres).pipe(
      map(wheres => {

        const newQuery = Object.assign({}, query);

        wheres.forEach(where => {
          if (newQuery.wheres == null) newQuery.wheres = where;
          else newQuery.wheres = [...newQuery.wheres].concat(where);
        })
        

        

        return newQuery;
      }));

  });


  
}
